
import {
  required,
  minLength,
} from 'vuelidate/lib/validators';

import errorParseNetwork from '~/helpers/errorParseNetwork';
import { ymGoalCheck } from '~/helpers/ym_helper';

export default {
  name: 'PopUpRedirect',

  data() {
    return {
      form: {
        name: '',
        phone: '',
      },

      accept: true,
    };
  },

  validations() {
    const form = {
      phone: {
        required,
        minLength: minLength(18),
      },
    };

    return {
      form,
    };
  },

  computed: {
    settings() {
      return this.$store.state['pop-up-redirect']?.settings || {};
    },
    formType() {
      return this.settings?.type || 'Заявка - обратный звонок';
    },
    phoneNumber() {
      return this.settings?.type || '8 (349) 492-72-27';
    },

    errorPhone() {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null;
      }

      if (!error.required) {
        return 'Обязательно к заполнению';
      }
      if (!error.minLength) {
        return 'Неправильный формат ввода';
      }

      return null;
    },
  },

  methods: {
    async submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$store.commit('loading/setLoading', true);

      const body = {
        type: this.formType,
        name: this.form.name,
        phone: (this.form?.phone || '').replace(/[^\d]/g, ''),
        message: this.formMessage || this.form.message,
        email: this.form.email,
        url: window.location.href,
        source: '',
        title: this.formTitle,
        additional_data: '',
      };

      const response = await this.$api.agent.transport
        .post('/form/send', body)
        .then((res) => res.data)
        .catch((err) => ({ error: errorParseNetwork(err.response) }));

      if (response.error) {
        this.$toast.error(response.error);
        this.$store.commit('loading/setLoading', false);
        return;
      }

      this.closeForm();
      this.eventSuccessCallback();
      this.sendMetriks();
      this.closeForm();
      this.$v.$reset();

      this.$store.commit('loading/setLoading', false);
      this.$toast.success('Ваша заявка успешно отправлена');
    },

    closeForm() {
      this.form = {
        name: '',
        phone: '',
      };
      this.$v.$reset();
      this.$store.commit('pop-up-redirect/closePopUp');
    },

    sendMetriks() {
      if (this.settings?.yandexMetriks) {
        ymGoalCheck({
          ymGoal: this.settings?.yandexMetriks?.ymGoal,
          ymNumber: this.settings?.yandexMetriks?.ymNumber,
        });
      }
    },
    eventSuccessCallback() {
      if (!this.settings?.successCallback) {
        return;
      }

      this.settings.successCallback();
    },
  },
};
